import React, { Component } from "react";
import { graphql } from "gatsby";

class HubspotForm extends Component {
  constructor({ data }) {
    super();
    this.data = data;
  }
  componentDidMount() {
    const formCreate = (options) => {
      if (!window.hbspt) {
        setTimeout(() => {
          formCreate(options);
        }, 100);
      } else {
        window.hbspt.forms.create({ ...options });
      }
    };
    formCreate({
      portalId: "7001828",
      formId: this.data.formId,
      target: `#${this.data.id}`,
    });
  }
  render() {
    return (
      <section className="hds-container hds-text-color">
        <div id={this.data.id} className="hds-section bg-gray" />
      </section>
    );
  }
}

export default HubspotForm;

export const hubspotFormQuery = graphql`
  fragment HubspotFormComponent on DatoCmsHubspotForm {
    internal {
      type
    }
    id
    formId
  }
`;
